import { useEffect, useMemo, useState } from 'react';

export function useTelegramWebApp() {
  const [ready, setReady] = useState(false);

  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

  useEffect(() => {
    if (!tg) {
      setReady(true);
      return;
    }
    tg.ready();
    tg.expand();
    setReady(true);
  }, [tg]);

  const theme = useMemo(() => {
    if (!tg) return { bg: '#0d1117', text: '#e6edf3', hint: '#8b949e', button: '#238636' };
    const p = tg.themeParams;
    return {
      bg: p.bg_color || (tg.colorScheme === 'dark' ? '#212121' : '#ffffff'),
      text: p.text_color || (tg.colorScheme === 'dark' ? '#ffffff' : '#000000'),
      hint: p.hint_color || '#8b949e',
      button: p.button_color || '#3390ec',
      buttonText: p.button_text_color || '#ffffff',
    };
  }, [tg, ready]);

  return {
    tg,
    ready,
    initData: tg?.initData ?? '',
    user: tg?.initDataUnsafe?.user,
    theme,
    haptic: (style: 'light' | 'medium' | 'heavy' = 'medium') =>
      tg?.HapticFeedback?.impactOccurred(style),
  };
}
